import {
	GridColumnProps,
	GridHeaderCellProps,
} from "@progress/kendo-react-grid";
import i18n from "../../../../i18n";
import CellPopover from "ui/grid/DescriptionCell";
import { NumericalCell } from "ui/grid/GridCommandCell";
import { CLASSNAME } from "utils/constant";
import { FC } from "react";
import { formatNorwegianNumber } from "utils/helper";
import { calculateFieldStats } from "utils/statUtils";
import React from "react";

let t = i18n.t;

const GROUP_FOOTER = "fresh-sales-group-footer-cell";

export const dailySalesFreshColumnItem = (data: any[] = []) => {
	const gridItems: GridColumnProps[] = [
		{
			field: "productText",
			title: t("Product"),
			cells: {
				data: (props) => <CellPopover {...props} />,
				footerCell: (props) => (
					<td className="td-bold no-border">
						{t("Total")}
					</td>
				),
				groupFooter: (props) => {
					if (props.dataItem?.field === "group1") {
						return (
							<td className={`td-bold no-border ${GROUP_FOOTER}`}>
								<div style={{ marginTop: "5px" }}>
									Sum {props.dataItem.value}
								</div>
							</td>
						);
					}
					return <td className="no-border" />;
				},
			},
			className: `no-border`,
		},

		{
			field: "netLiveWeightKg",
			title: t("Weight"),
			cells: {
				data: (props) => <NumericalCell {...props} unit={"kg"} style={{}} />,
				headerCell: (props) => <NumericalHeader {...props} />,
				footerCell: (props) => (
					<td className={`${CLASSNAME.TableNumeric} no-border td-bold`}>
						{`${formatNorwegianNumber(calculateFieldStats(data, "netLiveWeightKg").sum, 2, 2)} kg`}
					</td>
				),
				groupFooter: (props) => {
					if (props.dataItem?.field === "group1") {
						return (
							<td className={`${CLASSNAME.TableNumeric} no-border td-bold ${GROUP_FOOTER}`}>
								<div style={{ marginTop: "5px" }}>
									{`${formatNorwegianNumber(props.dataItem.aggregates.netLiveWeightKg.sum, 2, 2)} kg`}
								</div>
							</td>
						);
					}
					return <td className="no-border" />;
				},
			},
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "maxPrice",
			title: t("HighestPrice"),
			cells: {
				data: (props) => <NumericalCell {...props} unit={"kr"} />,
				headerCell: (props) => <NumericalHeader {...props} />,
				footerCell: (props) => <td className="no-border" />,
				groupFooter: (props) => <td className={`no-border ${GROUP_FOOTER}`} />,
			},
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "averagePrice",
			title: t("AveragePrice"),
			cells: {
				data: (props) => <NumericalCell {...props} unit={"kr"} />,
				headerCell: (props) => <NumericalHeader {...props} />,
				footerCell: (props) => <td className="no-border" />,
				groupFooter: (props) => <td className={`no-border ${GROUP_FOOTER}`} />,
			},
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "",
			title: "",
			cells: {
				footerCell: (props) => <td className="no-border" />,
				groupFooter: (props) => <td className={`no-border ${GROUP_FOOTER}`} />,
			},
			className: `no-border`,
		},
	];
	return gridItems;
};

export const NumericalHeader: FC<
	GridHeaderCellProps & { style?: React.CSSProperties } & any
> = (props) => {
	return (
		<th style={{ ...props.style, textAlign: "end", paddingRight: "10px" }}>
			{props.title}
		</th>
	);
};
